module.exports = __webpack_public_path__ + "media/images/cement-rw-b7110d1a523e81dda1290c14ff9f20db.jpg";